import { commitMutation, graphql } from 'react-relay';
import { ConnectionHandler } from 'relay-runtime';

const mutation = graphql`
    mutation CreateProjectMutation($input: CreateProjectMutationInput!) {
        createProject(input: $input) {
            project {
                serviceId
                createdDate
                installDate
                name
                portfolio {
                    serviceId
                }
                shippingAddress {
                    city
                    country
                    line1
                    state
                    zipCode
                }
            }
        }
    }
`;

export function commit(environment, args) {
    const { installDate, name, onCompleted, onError, userId, viewerId } = args;

    return commitMutation(environment, {
        mutation,
        variables: {
            input: {
                installDate,
                name,
                userId,
            },
        },
        updater: store => {
            if (viewerId) {
                const viewer = store.get(viewerId);
                const payload = store.getRootField('createProject');
                const newProject = payload && payload.getLinkedRecord('project');
                if (newProject) {
                    const connection = ConnectionHandler.getConnection(
                        viewer,
                        'TagProject_projects',
                        { userIds: [userId] }
                    );
                    if (connection) {
                        const newEdge = ConnectionHandler.createEdge(
                            store,
                            connection,
                            newProject,
                            'edge'
                        );
                        ConnectionHandler.insertEdgeAfter(connection, newEdge);
                    }
                }
            }
        },
        onCompleted,
        onError,
    });
}
